import {
  Box,
  Button,
  Grid,
  FormControl,
  FormLabel,
  TextField,
} from "@mui/material";
import { ErrorMessage, Form, Formik, FormikProps } from "formik";
import { useRef } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { addStoreSettings } from "../../../redux/reducer/features/Integration/DmsSetupSlice";

interface HighImpactSettingProps {
  handleNext: any;
  handleBack: any;
}

interface HighImpactFormValues {
  siteName: string;
  storeUrl: string;
}

export const HighImpactValidationSchema = Yup.object().shape({
  siteName: Yup.string()
    .required("Store Name is required")
    .min(3, "Store Name must be at least 3 characters"),
  storeUrl: Yup.string()
    .required("Store URL is required")
    .url("Please enter a valid URL"),
});

export const HighImpactSetting: React.FunctionComponent<
  HighImpactSettingProps
> = ({ handleNext, handleBack }) => {
  const formRef = useRef<FormikProps<any>>(null);
  const dispatch = useDispatch();

  const handleSubmit = (values: HighImpactFormValues) => {
    // Save store settings to Redux
    dispatch(
      addStoreSettings({
        token: "", // No token needed for HiImpact
        url: values.storeUrl,
        siteName: values.siteName,
      })
    );
    // Proceed to next step
    handleNext();
  };

  return (
    <Box minHeight={"80vh"}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          p: 0.5,
          mt: 2,
        }}
      >
        <Button variant="outlined" size="small" onClick={handleBack}>
          Back
        </Button>
      </Box>

      <Grid container style={{ justifyContent: "center" }}>
        <Grid item xs={12} sm={6}>
          <Formik
            initialValues={{ siteName: "", storeUrl: "" }}
            validationSchema={HighImpactValidationSchema}
            onSubmit={handleSubmit}
            innerRef={formRef}
          >
            {({ values, handleChange, handleBlur }) => (
              <Form>
                <FormControl
                  sx={{ m: 3 }}
                  component="fieldset"
                  variant="standard"
                  style={{ alignItems: "center" }}
                >
                  <FormLabel component="h2" sx={{ fontSize: "1.5rem", mb: 3 }}>
                    HiImpact Setup
                  </FormLabel>

                  <Grid container spacing={3} p={2}>
                    <Grid item sm={12}>
                      <TextField
                        id="siteName"
                        name="siteName"
                        label="Store Name"
                        fullWidth
                        variant="standard"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.siteName}
                        helperText={<ErrorMessage name="siteName" />}
                        error={
                          !!formRef.current?.errors?.siteName &&
                          !!formRef.current?.touched?.siteName
                        }
                      />
                    </Grid>
                    <Grid item sm={12}>
                      <TextField
                        id="storeUrl"
                        name="storeUrl"
                        label="Store URL"
                        fullWidth
                        variant="standard"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.storeUrl}
                        helperText={<ErrorMessage name="storeUrl" />}
                        error={
                          !!formRef.current?.errors?.storeUrl &&
                          !!formRef.current?.touched?.storeUrl
                        }
                      />
                    </Grid>
                    <Grid item sm={12}>
                      <Button
                        variant="contained"
                        type="submit"
                        size="small"
                      >
                        Save & Continue
                      </Button>
                    </Grid>
                  </Grid>
                </FormControl>
              </Form>
            )}
          </Formik>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HighImpactSetting;
